import { ModifyPlanComponent } from "./modify-plan.component";
export var ModifyPlanModule = angular
    .module('modifyPlan', [])
    .component(ModifyPlanComponent.selector, ModifyPlanComponent.component)
    .name;
//# sourceMappingURL=modify-plan.module.js.map